import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ForgotForm } from '../../components/forms/ForgotForm';
import { service } from '../../helpers';
import { doLogin } from '../../redux/reducers/auth';
import styles from './forgot.scss';
import { showAndHide } from '../../redux/reducers/message';

class Forgot extends Component {
  constructor(props) {
    super(props);
    this.hasError = false;
    this.state = {};
  }

  handleSubmit = async (values) => {
    try {
      const result = await service.post('auth/password/reset/', values);
      await this.handleResult(result);
      return false;
    } catch (e) {
      return this.handleError(e);
    }
  };

  handleResult = () => {
    this.props.showAndHide({
      type: 'success',
      text: 'Check your email for a reset link',
    });
  };

  handleError = (error) => {
    const text = error.json ? error.json.error : 'Unknown error';
    this.props.showAndHide({ type: 'An Error occurred', text });
  };

  componentDidMount = () => {
    if (this.props.auth.loaded && this.props.auth.token) {
      this.props.history.push('/submissions/new');
    }
  };

  render() {
    return (
      <Container className={styles.container}>
        <Row className='login'>
          <div className='std-form-container mx-auto my-auto'>
            <div>
              <div id='login' className='zombieDiv'>
                <img src='./images/giphy_1.gif' height='80px' alt='zombie' />
                <p>Reset your password</p>
              </div>
            </div>
            <ForgotForm handleSubmit={this.handleSubmit} />
          </div>
        </Row>
      </Container>
    );
  }
}

Forgot.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any,
};

const mapStateToProps = ({ auth }) => ({
  auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ doLogin, showAndHide }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Forgot);
